<div class="dedup-tab-content">
    <div class="tab-header" *ngIf="dedupItems.length === 0">
        <h4>Dedup Operations</h4>
        <p>Compare items for {{ currentEntity || 'No Entity Selected' }}</p>
    </div>

    <div class="tab-body">
        <!-- Controls Section -->
        <div class="dedup-controls noselect" *ngIf="dedupItems.length > 0">
            <div class="control-group">
                <button class="btn btn-secondary" (click)="clearAllDedupItems()">
                    <i class="material-icons">clear_all</i>
                    Clear All
                </button>
                <button class="btn btn-warning" (click)="clearAllSelections()">
                    <i class="material-icons">check_box_outline_blank</i>
                    Clear Selections
                </button>
                <button class="btn btn-success" [disabled]="isPerformingDedup || isPolling" (click)="performDedup()">
                    <i class="material-icons" *ngIf="!isPerformingDedup && !isPolling">merge_type</i>
                    <i class="loading-spinner-small" *ngIf="isPerformingDedup || isPolling"></i>
                    <span>{{ isPerformingDedup || isPolling ? 'Processing...' : 'Dedup' }}</span>
                </button>
                <div class="switch-container">
                    <label class="switch">
                        <input type="checkbox" [checked]="showOnlyDiffs" (change)="toggleShowOnlyDiffs()" />
                        <span class="slider round">
                            <span class="switch-label"> Show Only Diffs </span>
                        </span>
                    </label>
                </div>
            </div>

            <div class="dedup-status">
                <span class="status-badge" [class.active]="isActive"> {{ dedupItems.length }} items in dedup </span>
                <!-- Dedup Status Indicator -->
                <span
                    class="status-badge dedup-status-badge"
                    *ngIf="dedupStatus"
                    [class.status-in-progress]="dedupStatus === 'in_progress'"
                    [class.status-success]="dedupStatus === 'success'"
                    [class.status-error]="dedupStatus === 'error'"
                >
                    <i class="material-icons" *ngIf="dedupStatus === 'in_progress'">hourglass_empty</i>
                    <i class="material-icons" *ngIf="dedupStatus === 'success'">check_circle</i>
                    <i class="material-icons" *ngIf="dedupStatus === 'error'">error</i>
                    <span>{{ dedupStatus === 'in_progress' ? 'In Progress' : dedupStatus === 'success' ? 'Success' : 'Error' }}</span>
                </span>
            </div>
        </div>
        <!-- Dedup Status View -->
        <div class="dedup-status-view" *ngIf="dedupStatus && dedupStatusResponse">
            <!-- In Progress View -->
            <div class="status-card status-in-progress-card" *ngIf="dedupStatus === 'in_progress'">
                <button class="close-btn" (click)="closeStatusView()" title="Close">
                    <i class="material-icons">close</i>
                </button>
                <div class="status-header">
                    <i class="material-icons">hourglass_empty</i>
                    <h5>Deduplication in Progress</h5>
                </div>
                <div class="status-content">
                    <p>Your deduplication request is being processed. Please wait...</p>
                    <div class="status-details" *ngIf="dedupStatusResponse">
                        <div class="detail-item"><strong>Master Table:</strong> {{ dedupStatusResponse.masterTable }}</div>
                        <div class="detail-item"><strong>Golden Key:</strong> {{ dedupStatusResponse.goldenKey }}</div>
                        <div class="detail-item"><strong>Stage:</strong> {{ dedupStatusResponse.stage }}</div>
                    </div>
                    <div class="loading-indicator">
                        <div class="spinner"></div>
                        <span>Checking status every 4 seconds...</span>
                    </div>
                </div>
            </div>
            <!-- Success View -->
            <div class="status-card status-success-card" *ngIf="dedupStatus === 'success'">
                <button class="close-btn" (click)="closeStatusView()" title="Close">
                    <i class="material-icons">close</i>
                </button>
                <div class="status-header">
                    <i class="material-icons">check_circle</i>
                    <h5>Deduplication Completed Successfully</h5>
                </div>
                <div class="status-content">
                    <p>The deduplication process has completed successfully.</p>
                    <div class="status-details" *ngIf="dedupStatusResponse">
                        <div class="detail-item"><strong>Master Table:</strong> {{ dedupStatusResponse.masterTable }}</div>
                        <div class="detail-item"><strong>Golden Key:</strong> {{ dedupStatusResponse.goldenKey }}</div>
                        <div class="detail-item" *ngIf="dedupStatusResponse.merging_keys && dedupStatusResponse.merging_keys.length > 0">
                            <strong>Merged Keys:</strong> {{ dedupStatusResponse.merging_keys.join(', ') }}
                        </div>
                        <div class="detail-item" *ngIf="dedupStatusResponse.golden_fields">
                            <strong>Golden Fields:</strong>
                            <pre>{{ dedupStatusResponse.golden_fields | json }}</pre>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Error View -->
            <div class="status-card status-error-card" *ngIf="dedupStatus === 'error'">
                <button class="close-btn" (click)="closeStatusView()" title="Close">
                    <i class="material-icons">close</i>
                </button>
                <div class="status-header">
                    <i class="material-icons">error</i>
                    <h5>Deduplication Failed</h5>
                </div>
                <div class="status-content">
                    <p class="error-message" *ngIf="dedupStatusResponse?.details">
                        {{ dedupStatusResponse.details }}
                    </p>
                    <p class="error-message" *ngIf="!dedupStatusResponse?.details">The deduplication process encountered an error.</p>
                    <div class="status-details" *ngIf="dedupStatusResponse">
                        <div class="detail-item"><strong>Master Table:</strong> {{ dedupStatusResponse.masterTable }}</div>
                        <div class="detail-item"><strong>Golden Key:</strong> {{ dedupStatusResponse.goldenKey }}</div>
                        <div class="detail-item"><strong>Stage:</strong> {{ dedupStatusResponse.stage }}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Reverse Grid Display -->
        <div class="dedup-grid-section" *ngIf="dedupRows.length > 0">
            <h5>Property Comparison</h5>
            <div class="reverse-grid-container">
                <div class="grid-wrapper">
                    <!-- Header Row -->
                    <div class="grid-header">
                        <div class="property-column">Property</div>
                        <div
                            class="item-column"
                            *ngFor="let item of dedupItems; let i = index"
                            draggable="true"
                            (dragstart)="onItemDragStart(i, $event)"
                            (dragover)="onItemDragOver(i, $event)"
                            (drop)="onItemDrop(i, $event)"
                            [class.drag-source]="dragStartIndex === i"
                            [class.drag-over]="dragOverIndex === i"
                            [class.survivor-column]="isSurvivorRecord(item.id)"
                            [class.ignored-column]="isRecordIgnored(item.id)"
                        >
                            <div class="item-header">
                                <div class="record-actions">
                                    <button
                                        class="survivor-btn"
                                        [class.active]="isSurvivorRecord(item.id)"
                                        (click)="setSurvivorRecord(item.id)"
                                        [title]="isSurvivorRecord(item.id) ? 'Survivor Record' : 'Set as Survivor'"
                                    >
                                        <i class="material-icons">{{ isSurvivorRecord(item.id) ? 'star' : 'star_border' }}</i>
                                    </button>
                                    <button
                                        class="ignore-btn"
                                        [class.active]="isRecordIgnored(item.id)"
                                        (click)="toggleIgnoreRecord(item.id)"
                                        [title]="isRecordIgnored(item.id) ? 'Ignored Record' : 'Ignore Record'"
                                    >
                                        <i class="material-icons">{{ isRecordIgnored(item.id) ? 'visibility_off' : 'visibility' }}</i>
                                    </button>
                                    <button class="remove-btn" (click)="removeRecordFromDedup(item.id)" [title]="'Remove this record from dedup'">
                                        <i class="material-icons">close</i>
                                    </button>
                                </div>
                                <div class="record-info">
                                    <input type="checkbox" class="item-checkbox" [checked]="isItemSelected(item.id)" (change)="toggleItemSelection(item.id)" />
                                    <span class="item-label">Item {{ i + 1 }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Data Rows -->
                    <div class="grid-body">
                        <div class="grid-row" *ngFor="let row of filteredDedupRows" [class.has-differences]="hasRowDifferences(row)">
                            <div class="property-cell">
                                <div class="property-header">
                                    <strong class="property-name">{{ getHeaderName(row.property) }}</strong>
                                    <span
                                        class="difference-indicator"
                                        *ngIf="hasRowDifferences(row)"
                                        [title]="'This field has ' + getDifferentValuesCount(row) + ' values that differ from the majority'"
                                    >
                                        <i class="material-icons">warning</i>
                                        <span class="diff-count">{{ getDifferentValuesCount(row) }}</span>
                                    </span>
                                </div>
                            </div>
                            <div
                                class="value-cell"
                                *ngFor="let item of dedupItems; let i = index"
                                [class.different]="isValueDifferent(row.values, item.id)"
                                [class.item-separator]="i >= 0"
                                [class.survivor-cell]="isSurvivorRecord(item.id)"
                                [class.ignored-cell]="isRecordIgnored(item.id)"
                                [class.editing]="isCellEditing(row.property, item.id)"
                            >
                                <div class="value-content">
                                    <input
                                        type="checkbox"
                                        class="cell-checkbox"
                                        [checked]="isCellSelected(row.property, item.id)"
                                        [disabled]="isRecordIgnored(item.id)"
                                        (change)="toggleCellSelection(row.property, item.id)"
                                    />
                                    <!-- Display mode -->
                                    <!-- Display mode -->
                                    <span
                                        *ngIf="!isCellEditing(row.property, item.id)"
                                        class="cell-value"
                                        [class.unique-value]="isValueDifferent(row.values, item.id)"
                                        [class.editable-cell]="!isRecordIgnored(item.id) && isEditableField(row.property)"
                                        [class.id-field]="isIdField(row.property)"
                                        [title]="
                                            !isEditableField(row.property)
                                                ? isIdField(row.property)
                                                    ? 'ID field - not editable'
                                                    : 'Read-only field'
                                                : isValueDifferent(row.values, item.id)
                                                  ? 'This value differs from other records'
                                                  : !isRecordIgnored(item.id)
                                                    ? 'Click to edit'
                                                    : ''
                                        "
                                        (click)="!isRecordIgnored(item.id) && isEditableField(row.property) && startCellEdit(row.property, item.id)"
                                    >
                                        {{ getCellValue(row.property, item.id) || 'N/A' }}
                                    </span>

                                    <!-- Edit mode -->
                                    <div *ngIf="isCellEditing(row.property, item.id)" class="cell-edit-container">
                                        <input
                                            type="text"
                                            class="cell-edit-input"
                                            [value]="editedCellValue"
                                            (input)="updateEditedValue($event.target.value)"
                                            (keydown.enter)="saveCellEdit()"
                                            (keydown.escape)="cancelCellEdit()"
                                            (blur)="saveCellEdit()"
                                            #editInput
                                        />
                                        <div class="cell-edit-actions">
                                            <button type="button" class="edit-save-btn" (click)="saveCellEdit()" title="Save changes">
                                                <i class="material-icons">check</i>
                                            </button>
                                            <button type="button" class="edit-cancel-btn" (click)="cancelCellEdit()" title="Cancel editing">
                                                <i class="material-icons">close</i>
                                            </button>
                                        </div>
                                    </div>
                                    <span class="value-badge" *ngIf="isValueDifferent(row.values, item.id)" title="Unique value">
                                        <i class="material-icons">priority_high</i>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="dedupItems.length === 0">
            <i class="material-icons">find_replace</i>
            <h5>No Items in Dedup</h5>
            <p>Right-click on items in the master table to add them to dedup for comparison.</p>
            <ul>
                <li>Right-click on any row in the master table</li>
                <li>Select "Add to Dedup" from the context menu</li>
                <li>Compare properties in the grid view</li>
                <li>Identify duplicates and resolve conflicts</li>
            </ul>
        </div>
    </div>
</div>
